export const locationValidationMessages = {
  numero: {
    pattern: 'Este Nº inválido.',
    maxlength: 'O Nº deve conter no máximo 60 caracteres.',
    required: 'O Nº é obrigatório.',
    isEmptyValue: 'Valor inválido!'
  },
  bairro: {
    required: 'O bairro é obrigatório.',
    minlength: 'Este nome de bairro é muito curto.',
    maxlength: 'O bairro deve conter no máximo 60 caracteres.',
    isEmptyValue: 'Valor inválido, remova os espaços!'
  },
  cep: {
    required: 'O cep é obrigatório.',
    pattern: 'Este cep é inválido.',
    maxlength: 'O cep deve conter no máximo 8 caracteres',
    notFound: 'Cep não encontrado.',
    isEmptyValue: 'Valor inválido, remova os espaços!'
  },
  municipio: {
    required: 'O municipio é obrigatório.'
  },
  logradouro: {
    required: 'O logadrouro é obrigatório',
    maxlength: 'O logradouro deve conter no máximo 255 caracteres.',
    isEmptyValue: 'Valor inválido, remova os espaços!'
  },
  complemento: {
    maxlength: 'O complemento deve conter no máximo 60 caracteres.',
    minlength: 'Este complemento é muito curto.',
    isEmptyValue: 'Valor inválido, remova os espaços!'
  },
  ponto_referencia: {
    maxlength: 'O ponto de referência deve conter no máximo 500 caracteres.',
    isEmptyValue: 'Valor inválido, remova os espaços!'
  }
};

export const companyValidationMessages = {
  user: {
    typeIs: 'Este usuário é inválido.',
    duplicate: 'Este usuário já está sendo ultilizado em outro vendedor.',
    isEmptyValue: 'Valor inválido, remova os espaços!'
  },
  cpf_cnpj: {
    repeated: 'Informação já cadastrada.',
    mask: 'Valor inválido.',
    required: 'O CPF/CNPJ é obrigatório',
    pattern: 'Este CPF/CNPJ é inválido.',
    maxlength: 'O CPF/CNPJ deve conter no máximo 14 caracteres.',
    validateCPF: 'Este CPF é inválido.',
    validateCNPJ: 'Este CNPJ é inválido.',
    duplicate:
      'CPF/CNPJ já existe na base de dados. Verifique se o cadastro existente com esse dado esta correto.'
  },
  apelido_nome_fantasia: {
    required: 'Esta informação é obrigatória.',
    minlength: 'Este nome é muito curto',
    maxlength: 'Este nome é muito longo.',
    isEmptyValue: 'Valor inválido, remova os espaços!'
  },
  nome_razao_social: {
    required: 'Esta informação é obrigatória.',
    maxlength: 'O nome deve conter no máximo 60 caracteres',
    minlength: 'Esta razão social é muito curta.',
    isEmptyValue: 'Valor inválido, remova os espaços!'
  },
  nome: {
    required: 'O nome é obrigatório.',
    pattern: 'Este nome é inválido.',
    maxlength: 'O nome deve conter no máximo 40 caracteres.',
    isEmptyValue: 'Valor inválido, remova os espaços!'
  },
  nome_fantasia: {
    required: 'O nome fantasia é obrigatório.',
    pattern: 'Este nome fantasia é invalido.',
    maxlength: 'O nome fantasia deve conter no máximo 60 caracteres.',
    minlength: 'Este nome fantasia é muito curto.',
    isEmptyValue: 'Valor inválido, remova os espaços!'
  },
  observacao: {
    isEmptyValue: 'Valor inválido, remova os espaços!',
    maxlength: 'A observação deve conter no máximo 500 caracteres.',
  },
  rg: {
    pattern: 'Este RG é invalido.',
    maxlength: 'O RG deve conter no máximo 20 caracteres.',
    existSpecialChar: 'Valor inválido, não aceita pontuação!',
    isEmptyValue: 'Valor inválido, remova os espaços!'
  },
  razao_social: {
    required: 'A Razão social é obrigatória.',
    minlength: 'Esta razão social é muito curta.',
    maxlength: 'A razão social deve conter no máximo 60 caracteres.',
    isEmptyValue: 'Valor inválido, remova os espaços!'
  },
  rg_insc_est: {
    pattern: 'Este valor é inválido.',
    maxlength: 'O campo deve conter no máximo 20 caracteres.',
    duplicate: 'O RG/Insc. Estadual já existe na base de dados!',
    existSpecialChar: 'Valor inválido, não aceita pontuação!',
    isEmptyValue: 'Valor inválido, remova os espaços!'
  },
  data_nascimento: {
    invalidDate: 'Esta data é invalida.',
    isEmptyValue: 'Valor inválido, remova os espaços!'
  }
};

export const contactsValidationMessages = {
  contato: {
    maxlength: 'O contato deve conter no máximo 30 caracteres',
    required: 'O contato é obrigatório.',
    isEmptyValue: 'Valor inválido, remova os espaços!'
  },
  tag: {
    maxlength: 'O cargo deve conter no máximo 20 caracteres',
    isEmptyValue: 'Valor inválido, remova os espaços!'
  }
};
